<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showMerchantDetailPaymentSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div class="headerTitle">
            <div class="cs-header-title">Payment Details</div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                       [styleClass]="'app-scrollpanel'">

            <div class="payment-title">Nominated Payout Account</div>
              <div *ngFor="let payment of payments">
                <div class="flex flex-row" >
                  <div class="merchant-column merchant-column-50">
                     <div class="merchant-form">
                        <h5 class="payment-title-type">Payout Account Type</h5>
                         <div class="accountype">
                          <span>{{ payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet ? 'E-Wallet' : 'Bank'}}</span>
                        </div>
                     </div>
                   </div>
                   <div class="merchant-column merchant-column-50">
                      <div class="merchant-form">
                        <h5 class="payment-title-type">Bank Name</h5>
                          <div class="accountype">
                            <span>{{ payment.PayServiceName }}</span>
                         </div>
                        </div>
                     </div>
                </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                       <div class="merchant-form">
                          <h5 class="payment-title-type">Account Name</h5>
                           <div class="accountype">
                            <span>{{ payment.AccountName}}</span>
                          </div>
                       </div>
                     </div>
                     <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                          <h5 class="payment-title-type">Account Number</h5>
                            <div class="accountype">
                              <span>{{ payment.AccountNumber}}</span>
                           </div>
                          </div>
                       </div>
                  </div>
            </div>
            <!-- <div *ngIf="!isMerchant"> -->
                <div>
                <hr />

                <div class="verification-questions-body">
                    <div class="verification-questions-title">
                        Review
                    </div>
                    <div class="verification-questions" *ngFor="let item of questions">
                        <div class="question-column-70">
                            <div class="verification-name">{{item.name}}</div>
                        </div>
                        <div class="question-column-30">
                            <div class="verification-question-switch">
                                <p-inputSwitch [(ngModel)]="item.isChecked" (click)="addOrUpdateMerchantVerificationCheckList(item)"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <div class="merchant-form">
                        <div class="merchant-label-reasons">Other reasons</div>
                        <textarea class="textarea-description" rows="5" cols="30" [(ngModel)]="payment.RejectReason" placeholder="Type here..." pInputTextarea></textarea>
                    </div>
                </div>
            </div>
        </p-scrollPanel>

        <div class="flex justify-content-end mrg-10-0px">
            <button class="red-btn" pButton label="Reject" style="margin-right: 10px;" (click)="approvedOrReject(payoutAccountStatusEnum.Rejected)"></button>
            <button class="green-btn" pButton label="Approve" (click)="approvedOrReject(payoutAccountStatusEnum.Approved)"></button>
        </div>
    </div>

</p-sidebar>